



























import { Component, Prop, Vue } from 'vue-property-decorator';
import moment from 'moment';
import * as CCLookup from 'country-code-lookup';
import CountryFlag from '@/components/display/CountryFlag.vue';

@Component({
	components: {
		CountryFlag,
	},
})
export default class ProductCountryFlagRow extends Vue {
	@Prop({ required: true })
	public product!: any;

	get dateInTimezone() {
		const rawAddress = JSON.parse(this.product.site.address.rawAddress);
		const offset = rawAddress ? rawAddress[`utc_offset_minutes`] ?? null : null;
		return offset != null
			? moment()
					.utcOffset(offset)
					.format('h:mma dddd Do MMMM YYYY')
			: 'unknown';
	}

	public get countryCode(): string | null {
		const country = this.product.site.address.country;
		const search = CCLookup.byCountry(country);
		if (search == null) return null;
		return search.iso2;
	}
}
